import { obmSegmentsTableReducer } from '@domain/segments/segments-table/obm-segments-table/obm-segments-table.state';
import { combineReducers } from 'redux';
import { budgetManagerCampaignsModalReducer } from './modal/budget-manager-campaigns-modal.state';

export default combineReducers({
    modal: budgetManagerCampaignsModalReducer,
    table: obmSegmentsTableReducer,
});
